import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import React from 'react'
import { Box } from '@mui/material'
import useSelectedUserRoutes from 'src/Hooks/useSelectedUserRoutes'
import { BlankViewImageVariants, BlankView } from 'src/Components/blank-view'

interface BlankInstallationDashboardProps {
  imageVariant?: BlankViewImageVariants
  title?: string
  explanation?: string
}

/**
 * Blank view used if no installation can be shown
 */
const BlankInstallationDashboard: React.FC<BlankInstallationDashboardProps> = ({
  imageVariant = BlankViewImageVariants.Worried,
  title = 'dashboard.blank.text1',
  explanation = 'dashboard.blank.text2',
}) => {
  const { t } = useCustomTranslation()
  useSelectedUserRoutes(t('dashboard.title'))

  return (
    <Box display="flex" alignItems="center" justifyContent="center" flexDirection="column" mt={4}>
      <BlankView imageVariant={imageVariant} title={title} explanation={explanation} />
    </Box>
  )
}

export default BlankInstallationDashboard
